import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../assets/images/newLogo.png";
import Dropdown from "react-bootstrap/Dropdown";
import peopleImg from "../assets/images/people.png";
import medicineImg from "../assets/images/medicine.png";
import logoutImg from "../assets/images/logout.png";
import settingImg from "../assets/images/setting-2.png";
import delivery from "../assets/images/deliveries.png";
import transaction from "../assets/images/transaction.png";
import { useLocation } from "react-router-dom";
import { TbTransactionRupee } from "react-icons/tb";
import { MdOutlineDashboard } from "react-icons/md";
import { BsPeople } from "react-icons/bs";
import { AiOutlineMedicineBox } from "react-icons/ai";
import { CiDeliveryTruck } from "react-icons/ci";
import { RiEBikeLine } from "react-icons/ri";
import { RiContactsBookLine } from "react-icons/ri";
import { LuReceiptIndianRupee } from "react-icons/lu";
import { IoSettingsOutline } from "react-icons/io5";
import { RiLogoutCircleRLine } from "react-icons/ri";
import { RiShieldUserLine } from "react-icons/ri";
import { FaMagento } from "react-icons/fa";
import { GiMoneyStack } from "react-icons/gi";
import { FaEnvelopeOpenText } from "react-icons/fa6";
import { CiWallet } from "react-icons/ci";

export const Sidebar = ({ isOpen, toggleSidebar }) => {
  // const [activeMenu, setactiveMenu] = useState("dashboard");
  const location = useLocation();
  const pathname = location.pathname;
  const managePaths = [
    "/manage-admin",
    "/manage-wholesaler",
    "/manage-retailer",
    "/manage-ryder",
  ];

  const transactionPaths = [
    "/transaction-wholesaler",
    "/transaction-retailer",
    "/transaction-ryder",
  ];

  const navigate = useNavigate();
  const handleManageSelect = (eventKey) => {
    switch (eventKey) {
      case "Admin":
        navigate("/manage-admin");
        break;
      case "Wholesaler":
        navigate("/manage-wholesaler");
        break;
      case "Retailer":
        navigate("/manage-retailer");
        break;
      case "Ryder":
        navigate("/manage-ryder");
        break;
      default:
        break;
    }

    toggleSidebar();
  };

  // const handleTransactionSelect = (eventKey) => {
  //   switch (eventKey) {
  //     case "Wholesaler":
  //       navigate("/transaction-wholesaler");
  //       break;
  //     case "Retailer":
  //       navigate("/transaction-retailer");
  //       break;
  //     case "Ryder":
  //       navigate("/transaction-ryder");
  //       break;
  //     default:
  //       break;
  //   }

  //   toggleSidebar();
  // };

  const handleTransactionSelect = (eventKey) => {
    switch (eventKey) {
      case "Transactions":
        navigate("/whole-transactions");
        break;
      default:
        break;
    }

    toggleSidebar();
  };

  // const handleLogout = () => {
  //   localStorage.clear();
  //   navigate("/");
  // };

  const handleLogout = () => {
    try {
      localStorage.clear();
      sessionStorage.clear();

      if ("caches" in window) {
        caches.keys().then((names) => {
          names.forEach((name) => {
            caches.delete(name);
          });
        });
      }

      document.cookie.split(";").forEach((c) => {
        document.cookie = c
          .replace(/^ +/, "")
          .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
      });

      navigate("/");
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };

  return (
    <div
      style={{
        width: window.innerWidth >= 992 ? "250px" : "100vw", // Fixed width on large screens, full width on mobile

        padding: "10px",
        height: "100vh",
        position: "fixed",
        left: isOpen || window.innerWidth >= 992 ? "0" : "-100vw", // Always visible on large screens
        top: 0,
        transition: "left 0.3s ease-in-out",
        zIndex: 1000, // Ensure it appears above other elements
      }}
      className="sidebar"
    >
      {/* Close Button (Only Visible on Small Screens) */}
      {window.innerWidth < 992 && isOpen && (
        <button
          onClick={toggleSidebar}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "20px",
            cursor: "pointer",
            position: "absolute",
            right: "10px",
            top: "10px",
          }}
          className="close-btn"
        >
          ✖
        </button>
      )}

      <div className="sidebarLogo">
        <img src={logo} />
      </div>
      <ul className="sidebar-list">
        <li
          onClick={() => {
            toggleSidebar();
          }}
          className={pathname === "/dashboard" ? "activeMenu" : ""}
        >
          <a href="/dashboard">
            {" "}
            <span className="pe-2">
              {/* <img src={medicineImg} /> */}
              <MdOutlineDashboard />
            </span>
            Dashboard
          </a>
        </li>

        <li className={managePaths.includes(pathname) ? "activeMenu" : ""}>
          <Dropdown
            onSelect={handleManageSelect}
            className="customSidebarDropdown"
          >
            <Dropdown.Toggle id="dropdown-basic" className="dropdownManage">
              <span className="pe-2">
                {/* <img src={peopleImg} /> */} <BsPeople />
              </span>{" "}
              Manage
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item eventKey="Admin" className="dropdownItem">
                Admin
              </Dropdown.Item>
              <Dropdown.Item eventKey="Wholesaler" className="dropdownItem">
                Wholesaler
              </Dropdown.Item>
              <Dropdown.Item eventKey="Retailer" className="dropdownItem">
                Retailer
              </Dropdown.Item>
              <Dropdown.Item eventKey="Ryder" className="dropdownItem">
                Ryder
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </li>

        {/* <li className={transactionPaths.includes(pathname) ? "activeMenu" : ""}>
          <Dropdown
            onSelect={handleTransactionSelect}
            className="customSidebarDropdown"
          >
            <Dropdown.Toggle id="dropdown-basic" className="dropdownManage">
              <span className="pe-2">
                <TbTransactionRupee />
              </span>{" "}
              Transactions
            </Dropdown.Toggle>

             <Dropdown.Menu>
              <Dropdown.Item eventKey="Wholesaler" className="dropdownItem">
                Wholesaler
              </Dropdown.Item>
              <Dropdown.Item eventKey="Retailer" className="dropdownItem">
                Retailer
              </Dropdown.Item>
              <Dropdown.Item eventKey="Ryder" className="dropdownItem">
                Ryder
              </Dropdown.Item>
            </Dropdown.Menu>
            <Dropdown.Menu>
              <Dropdown.Item eventKey="Transactions" className="dropdownItem">
                Transactions
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </li> */}

        <li
          onClick={() => {
            toggleSidebar();
          }}
          className={pathname === "/whole-transactions" ? "activeMenu" : ""}
        >
          <a href="/whole-transactions">
            {" "}
            <span className="pe-2">
              <TbTransactionRupee />
            </span>
            Transactions
          </a>
        </li>

        <li
          onClick={() => {
            toggleSidebar();
          }}
          className={pathname === "/medicine" ? "activeMenu" : ""}
        >
          <a href="/medicine">
            {" "}
            <span className="pe-2">
              {/* <img src={medicineImg} /> */}
              <AiOutlineMedicineBox />
            </span>
            Medicine
          </a>
        </li>
        <li
          onClick={() => {
            toggleSidebar();
          }}
          className={pathname === "/delivery" ? "activeMenu" : ""}
        >
          <a href="/delivery">
            {" "}
            <span className="pe-2">
              {/* <img src={delivery} /> */}
              <CiDeliveryTruck />
            </span>
            Deliveries
          </a>
        </li>
        <li
          onClick={() => {
            toggleSidebar();
          }}
          className={pathname === "/ryder-zone" ? "activeMenu" : ""}
        >
          <a href="/ryder-zone">
            <span className="pe-2">
              <RiEBikeLine />
            </span>
            Ryder Zone
          </a>
        </li>
        <li
          onClick={() => {
            toggleSidebar();
          }}
          className={pathname === "/withdraw-request" ? "activeMenu" : ""}
        >
          <a href="/withdraw-request">
            <span className="pe-2">
              <GiMoneyStack />
            </span>
            Withdraw Request
          </a>
        </li>
        <li
          onClick={() => {
            toggleSidebar();
          }}
          className={pathname === "/invitations" ? "activeMenu" : ""}
        >
          <a href="/invitations">
            <span className="pe-2">
             <FaEnvelopeOpenText />
            </span>
            Invitations
          </a>
        </li>
          <li
          onClick={() => {
            toggleSidebar();
          }}
          className={pathname === "/gomak-cash" ? "activeMenu" : ""}
        >
          <a href="/gomak-cash">
            <span className="pe-2">
             <CiWallet />
            </span>
          Gomak Cash
          </a>
        </li>

        <li
          onClick={() => {
            toggleSidebar();
          }}
          className={pathname === "/global-setting" ? "activeMenu" : ""}
        >
          <a href="/global-setting">
            <span className="pe-2">
              <IoSettingsOutline />
            </span>
            Global Setting
          </a>
        </li>

        <li
          onClick={() => {
            toggleSidebar();
          }}
          className={pathname === "/referral-agents" ? "activeMenu" : ""}
        >
          <a href="/referral-agents">
            <span className="pe-2">
              <RiShieldUserLine />
            </span>
            Referral Agents
          </a>
        </li>

        <li
          onClick={() => {
            toggleSidebar();
          }}
          className={
            pathname === "/agent-withdrawl-requests" ? "activeMenu" : ""
          }
        >
          <a href="/agent-withdrawl-requests">
            <span className="pe-2">
              <RiShieldUserLine />
            </span>
            Agent Withdrawl Requests
          </a>
        </li>

        <li
          onClick={() => {
            toggleSidebar();
          }}
          className={pathname === "/agents-global-setting" ? "activeMenu" : ""}
        >
          <a href="/agents-global-setting">
            <span className="pe-2">
              <FaMagento />
            </span>
            Agents Global Setting
          </a>
        </li>

        <li
          onClick={() => {
            toggleSidebar();
          }}
          className={pathname === "/contactus-data" ? "activeMenu" : ""}
        >
          <a href="/contactus-data">
            <span className="pe-2">
              <RiContactsBookLine />
            </span>
            Contact Us Data
          </a>
        </li>
        {/* <li
          onClick={() => {
            toggleSidebar();
          }}
          className={pathname === "/pricing" ? "activeMenu" : ""}
        >
          <a href="/pricing">
            <span className="pe-2">
              <LuReceiptIndianRupee />
            </span>
            Pricings
          </a>
        </li> */}

        {/* <li
          onClick={() => {
            toggleSidebar();
          }}
          className={pathname === "/dash" ? "activeMenu" : ""}
        >
          <a href="#">
            <span className="pe-2">
              <IoSettingsOutline />
            </span>
            Settings
          </a>
        </li> */}

        <li
          onClick={() => {
            toggleSidebar();
            handleLogout();
          }}
        >
          <a href="/">
            {" "}
            <span className="pe-2">
              {/* <img src={logoutImg} /> */}
              <RiLogoutCircleRLine />
            </span>
            Logout
          </a>
        </li>
      </ul>
    </div>
  );
};
